import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainers(customer_id, agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  }
};
